/*
  "Watch the 20-second demo →" plays the video beside it instead of leaving the
  page.

  Progressive enhancement: the link ships with a real href, so without this file
  — or before it loads — it still navigates. Here it is upgraded to drive the
  <deferred-media> element in the other column, which the two are too far apart
  in the DOM to do with markup alone.

  The work itself is Dawn's: clicking the poster runs DeferredMedia.loadContent,
  which swaps the <template> for a real <video>. We only forward the click.
*/
(() => {
  if (window.hsVideoCue) return;
  window.hsVideoCue = true;

  // Far enough into view that starting playback is worth watching.
  const isVisible = (el) => {
    const r = el.getBoundingClientRect();
    const h = window.innerHeight || document.documentElement.clientHeight;
    return r.top < h * 0.8 && r.bottom > h * 0.2;
  };

  document.addEventListener('click', (event) => {
    const cue = event.target.closest('[data-hs-plays]');
    if (!cue) return;

    const poster = document.getElementById(cue.dataset.hsPlays);
    // No poster on this page means no video to play — let the href do its job.
    if (!poster) return;

    event.preventDefault();

    const media = poster.closest('deferred-media');
    if (media && media.hasAttribute('loaded')) {
      media.querySelector('video')?.play();
    } else {
      poster.click();
    }

    // On a narrow screen the media is stacked below the text, so playing without
    // scrolling starts a video the visitor cannot see.
    const frame = poster.closest('.hs-video__frame') || media;
    if (frame && !isVisible(frame)) frame.scrollIntoView({ block: 'center' });
  });
})();
